<template>
  <tickets-chat
    :loader="loader"
    :items="items"
    :fields="fields"
    :sort-key="sortKey"
    :sort-type="sortType"
    :additional-data="additionalData"
    @onSearch="search"
  />
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import TicketsChat from '../../components/tickets/list/TicketsChat'

export default {
  components: {
    TicketsChat,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'tickets',
      sortKey: 'updated_at',
    }
  },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
